import { useEffect } from 'react'

AvatarGenerator = ({ activeProject, prefix }) ->

  avatarId = "avatar-#{ prefix or '' }#{ activeProject?.id() }"

  useEffect( ->
    return if not activeProject?
    generateAvatar()
    undefined
  , [activeProject])

  generateAvatar = ->
    colors = [
      "#1abc9c", "#2ecc71", "#3498db", "#9b59b6",
      "#34495e", "#16a085", "#27ae60", "#2980b9",
      "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22",
      "#e74c3c", "#95a5a6", "#f39c12", "#d35400",
      "#c0392b", "#bdc3c7", "#10bfa7"
    ]
    initials = activeProject?.name
      .split(/[-_ ]/)                # split into n words
      .slice(0, 2)                   # discard all but the first two words
      .map((word) -> word.charAt(0)) # take first letter of each word
      .map(_.capitalize)             # capitalize each letter
      .join('')

    canvas = document.getElementById(avatarId)
    context = canvas.getContext('2d')

    context.fillStyle = colors[(initials.charCodeAt(0) - 65) % 19]
    context.fillRect(0, 0, canvas.width, canvas.height)
    context.font = "20px Arial"
    context.textAlign = 'center'
    context.fillStyle = '#fff'
    context.fillText(initials, 20, 28)

  <canvas
    id={avatarId}
    width="40"
    height="40"
    style={borderRadius: '50%'}
  />

export default AvatarGenerator
